import { render, staticRenderFns } from "./CustomerPortalSettings.vue?vue&type=template&id=02396798&"
import script from "./CustomerPortalSettings.vue?vue&type=script&lang=js&"
export * from "./CustomerPortalSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports